import {BlockAccordionSection} from './BlockAccordionSection'

import type {XcNwBlock_BlockAccordionType_Fragment} from '@sdox/api'

export const BlockAccordion = (props: XcNwBlock_BlockAccordionType_Fragment) => {
  const items = props.sections.map((section) => (
    <BlockAccordionSection
      key={section.id}
      {...section}
    />
  ))
  return (
    <div>{items}</div>
  )
}
